module.exports = __webpack_public_path__ + "3f16e137/img/settings-icon.121d9519.svg";